import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseForgotPasswordComponent } from './forgot-password.component';
import { TranslateModule } from '../../../../../node_modules/@ngx-translate/core';

const routes = [
    {
        path     : 'forgot',
        component: FuseForgotPasswordComponent
    }
];

@NgModule({
    declarations: [
        FuseForgotPasswordComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        TranslateModule
    ]
})

export class ForgotPasswordModule
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/forgot-password/forgot-password.module.ts